import { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { CONTACT_US_BUTTON, CONTACT_US_BUTTON_SCROLLED } from 'Constants/options'

const ContactUsButton = ({ onClick }) => {

  const [navBackground, setNavBackground] = useState(CONTACT_US_BUTTON)
  
  useEffect(() => {
      const handleScroll = () => {
          if (window.scrollY > 0) {
            return setNavBackground(CONTACT_US_BUTTON_SCROLLED)
          }
          return setNavBackground(CONTACT_US_BUTTON)
      }
      document.addEventListener('scroll', handleScroll)
      return () => {
          document.removeEventListener('scroll', handleScroll)
      }
  }, [])

  return (
    <div>
      <Button className={navBackground} onClick={onClick}>
        <Typography className="buttonText">Contact Us</Typography>
      </Button>
    </div>
  );
}

export default ContactUsButton;
